import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ATCCodeModel, ATCCodeFilterSettingsModel } from "../models/atcCode";
import AuthService from './authService';
class AtcCodeService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllAtcCodes() {
		return axios({
			url: `adminATCCode/getAll/`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getAllFilteredItems(from: number, numberOfRows: number, settings: ATCCodeFilterSettingsModel) {
		return axios({
			url: `adminATCCode/getAllFiltered/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getAtcCode(id: number) {
		return axios({
			url: `adminATCCode/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addAtcCode(atcCode: ATCCodeModel) {
		return axios({
			url: `adminATCCode/createAtcCode`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(atcCode)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editAtcCode(id: number, atcCode: ATCCodeModel) {
		return axios({
			url: `adminATCCode/updateAtcCode/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(atcCode)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteAtcCode(id: number) {
		return axios({
			url: `adminATCCode/deleteAtcCode/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownListLevelFive() {
		return axios({
			url: `adminATCCode/getDropdownListLevelFive/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	syncAtcCodes() {
		return axios({
			url: `adminATCCode/syncATC/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

}

export default AtcCodeService;
